module.exports = __webpack_public_path__ + "img/Weight.6c49d98c.svg";